(function () {
    var revealSelector = [
        'main h1',
        'main h2',
        'main h3',
        'main p',
        'main li',
        'main img',
        'main form',
        'main button',
        'main a[class*="button"]',
        '.filadelfia-main-content__breadcrumb',
        '.filadelfia-main-content__eyebrow',
        '.filadelfia-main-content__title',
        '.filadelfia-main-content__rte > *',
        '.filadelfia-about__title',
        '.filadelfia-about__media',
        '.filadelfia-about__body > *',
        '.filadelfia-login__title',
        '.filadelfia-login__text',
        '.filadelfia-collection__breadcrumb',
        '.filadelfia-collection__title',
        '.filadelfia-collection__toolbar',
        '.filadelfia-collection__filters-title',
        '.filadelfia-collection__filter-group',
        '.filadelfia-collection-card',
        '.filadelfia-collection__pagination',
        '.filadelfia-home-categories__eyebrow',
        '.filadelfia-home-categories__heading',
        '.filadelfia-home-categories__text',
        '.filadelfia-home-categories__card',
        '.filadelfia-home-product-slider__eyebrow',
        '.filadelfia-home-product-slider__heading',
        '.filadelfia-home-product-slider__text',
        '.filadelfia-home-product-card',
        '.filadelfia-home-product-slider__button',
        '.filadelfia-product-related__eyebrow',
        '.filadelfia-product-related__heading',
        '.filadelfia-product-related__text',
        '.filadelfia-product-related-card',
        '.filadelfia-product-related__nav-button',
        '.filadelfia-home-offer__slide.is-active .filadelfia-home-offer__eyebrow',
        '.filadelfia-home-offer__slide.is-active .filadelfia-home-offer__heading',
        '.filadelfia-home-offer__slide.is-active .filadelfia-home-offer__text',
        '.filadelfia-home-offer__slide.is-active .filadelfia-home-offer__feature',
        '.filadelfia-home-offer__slide.is-active .filadelfia-home-offer__image',
        '.filadelfia-home-offer__slide.is-active .filadelfia-home-offer__price-block',
        '.filadelfia-home-offer__slide.is-active .filadelfia-home-offer__installments',
        '.filadelfia-home-offer__slide.is-active .filadelfia-home-offer__actions',
        '.filadelfia-home-offer__slide.is-active .filadelfia-home-offer__microcopy',
        '.filadelfia-home-reviews__topline',
        '.filadelfia-home-reviews__intro',
        '.filadelfia-home-reviews__list',
        '.filadelfia-home-choose__media',
        '.filadelfia-home-choose__heading',
        '.filadelfia-home-choose__text',
        '.filadelfia-home-instagram__heading',
        '.filadelfia-second-section__value',
        '.filadelfia-product-hero__media-stage',
        '.filadelfia-product-hero__breadcrumb',
        '.filadelfia-product-hero__eyebrow',
        '.filadelfia-product-hero__title',
        '.filadelfia-product-hero__price-group',
        '.filadelfia-product-hero__pix',
        '.filadelfia-product-hero__installments',
        '.filadelfia-product-hero__rating',
        '.filadelfia-product-hero__form',
        '.filadelfia-product-hero__details',
        '.filadelfia-product-story__heading',
        '.filadelfia-product-story__text > *',
        '.filadelfia-product-story__image',
        '.filadelfia-product-reviews__heading',
        '.filadelfia-product-reviews__widget-shell',
        '.filadelfia-main-cart__title',
        '.filadelfia-main-cart__item',
        '.filadelfia-main-cart__summary',
        '.filadelfia-main-cart__reviews'
    ].join(',');

    var headerRevealSelector = [
        '.filadelfia-header__top-bar',
        '.filadelfia-header__brand',
        '.filadelfia-header__menu-item',
        '.filadelfia-header__actions > *',
        '.filadelfia-header__menu-toggle'
    ].join(',');

    var excludedClosestSelector = [
        '[data-cart-drawer]',
        '[data-sticky-atc]',
        '[data-cookie-popup]',
        '[data-search-overlay]',
        '[data-header-menu-drawer]',
        '.filadelfia-home-hero__ticker-wrap',
        '.filadelfia-floating-whatsapp',
        '.swiper-pagination',
        '.filadelfia-home-reviews__quote-word'
    ].join(',');

    var productCardSelector = [
        '.filadelfia-home-product-card',
        '.filadelfia-product-related-card',
        '.filadelfia-collection-card',
        '.filadelfia-cart-recommendation'
    ].join(',');

    var scanQueued = false;
    var scanBound = false;

    function prefersReducedMotion() {
        return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function isMeasurable(element) {
        if (!element || element.hidden) {
            return false;
        }

        var styles = window.getComputedStyle(element);
        var rect = element.getBoundingClientRect();

        return styles.display !== 'none' &&
            styles.visibility !== 'hidden' &&
            rect.width > 0 &&
            rect.height > 0;
    }

    function shouldReveal(element) {
        var productCard = element.closest(productCardSelector);

        if (productCard && productCard !== element) {
            return false;
        }

        return element &&
            element.dataset.siteRevealInitialized !== 'true' &&
            element.closest('main') &&
            !element.closest(excludedClosestSelector) &&
            isMeasurable(element);
    }

    function isInRevealZone(element) {
        var rect = element.getBoundingClientRect();
        var viewportHeight = window.innerHeight || document.documentElement.clientHeight;

        return rect.top < viewportHeight * 0.86 && rect.bottom > viewportHeight * 0.08;
    }

    function collectRevealElements(root) {
        var scope = root || document;
        var elements = [];

        if (scope.matches && scope.matches(revealSelector)) {
            elements.push(scope);
        }

        scope.querySelectorAll(revealSelector).forEach(function (element) {
            elements.push(element);
        });

        return Array.from(new Set(elements)).filter(shouldReveal);
    }

    function animateIn(element, vars) {
        if (element.dataset.siteRevealComplete === 'true') {
            return;
        }

        element.dataset.siteRevealComplete = 'true';
        window.gsap.fromTo(element, {
            autoAlpha: 0,
            y: vars.y || 34,
            scale: vars.scale || 0.985,
            filter: 'blur(' + (vars.blur || 16) + 'px)'
        }, {
            autoAlpha: 1,
            y: 0,
            scale: 1,
            filter: 'blur(0px)',
            duration: vars.duration || 0.78,
            delay: vars.delay || 0,
            ease: 'power2.out',
            overwrite: true,
            clearProps: 'filter,transform,visibility,opacity'
        });
    }

    function prepareRevealElement(element) {
        element.dataset.siteRevealInitialized = 'true';
        window.gsap.set(element, {
            autoAlpha: 0,
            y: 34,
            scale: 0.985,
            filter: 'blur(16px)'
        });
    }

    function revealElements(elements) {
        if (!elements.length) {
            return;
        }

        elements.forEach(prepareRevealElement);

        if (!('IntersectionObserver' in window)) {
            elements.forEach(function (element, index) {
                animateIn(element, {
                    y: 28,
                    blur: 14,
                    duration: 0.72,
                    delay: Math.min(index * 0.02, 0.18)
                });
            });
            return;
        }

        var observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (!entry.isIntersecting) {
                    return;
                }

                observer.unobserve(entry.target);
                animateIn(entry.target, {
                    y: 34,
                    blur: 16,
                    duration: 0.78
                });
            });
        }, {
            root: null,
            rootMargin: '0px 0px -14% 0px',
            threshold: 0.04
        });

        elements.forEach(function (element) {
            observer.observe(element);
        });
    }

    function revealPreparedElementsInView() {
        document.querySelectorAll('[data-site-reveal-initialized="true"]:not([data-site-reveal-complete="true"])').forEach(function (element) {
            if (isMeasurable(element) && isInRevealZone(element)) {
                animateIn(element, {
                    y: 34,
                    blur: 16,
                    duration: 0.78
                });
            }
        });
    }

    function queueScan() {
        if (scanQueued) {
            return;
        }

        scanQueued = true;
        window.requestAnimationFrame(function () {
            scanQueued = false;
            revealPreparedElementsInView();
        });
    }

    function bindScanEvents() {
        if (scanBound) {
            return;
        }

        scanBound = true;
        window.addEventListener('scroll', queueScan, { passive: true });
        window.addEventListener('resize', queueScan);
    }

    function revealHeroTicker(root) {
        var scope = root || document;
        var ticker = scope.matches && scope.matches('.filadelfia-home-hero__ticker-wrap')
            ? scope
            : scope.querySelector && scope.querySelector('.filadelfia-home-hero__ticker-wrap');

        if (!ticker || ticker.dataset.siteRevealInitialized === 'true' || !isMeasurable(ticker)) {
            return;
        }

        ticker.dataset.siteRevealInitialized = 'true';
        ticker.querySelectorAll('[data-site-reveal-initialized="true"]').forEach(function (element) {
            element.dataset.siteRevealComplete = 'true';
            window.gsap.set(element, {
                clearProps: 'filter,transform,visibility,opacity'
            });
        });

        animateIn(ticker, {
            y: 18,
            blur: 12,
            duration: 0.72
        });
    }

    function revealHeader(root) {
        var scope = root || document;
        var headerElement = scope.matches && scope.matches('[data-site-header]')
            ? scope
            : scope.querySelector && scope.querySelector('[data-site-header]');

        if (!headerElement || headerElement.dataset.headerRevealComplete === 'true') {
            return;
        }

        var elements = Array.prototype.slice.call(headerElement.querySelectorAll(headerRevealSelector))
            .filter(isMeasurable);

        if (!elements.length) {
            return;
        }

        headerElement.dataset.headerRevealComplete = 'true';
        elements.forEach(function (element) {
            element.dataset.headerRevealInitialized = 'true';
        });

        window.gsap.fromTo(elements, {
            autoAlpha: 0,
            y: -14,
            filter: 'blur(10px)'
        }, {
            autoAlpha: 1,
            y: 0,
            filter: 'blur(0px)',
            duration: 0.72,
            stagger: 0.045,
            ease: 'power2.out',
            clearProps: 'filter,transform,visibility,opacity'
        });
    }

    function initSiteReveal(root) {
        if (!window.gsap || prefersReducedMotion()) {
            return;
        }

        revealHeader(root);
        revealHeroTicker(root);
        revealElements(collectRevealElements(root));
        revealPreparedElementsInView();
        bindScanEvents();
    }

    window.filadelfiaSiteReveal = {
        init: initSiteReveal
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
            initSiteReveal(document);
        });
    } else {
        initSiteReveal(document);
    }

    window.addEventListener('load', function () {
        initSiteReveal(document);
    });

    window.setTimeout(function () {
        initSiteReveal(document);
    }, 700);

    document.addEventListener('shopify:section:load', function (event) {
        initSiteReveal(event.target);
    });
})();
